import { render, staticRenderFns } from "./AddCorrespondentModal.vue?vue&type=template&id=55601c52&scoped=true&"
import script from "./AddCorrespondentModal.vue?vue&type=script&lang=js&"
export * from "./AddCorrespondentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55601c52",
  null
  
)

export default component.exports